export default __webpack_public_path__ + "assets/images/champion_signup.svg";